import './style.less'
import ExternalModalCtrl from '../../modals/external/ctrl'
import SolutionModalCtrl from '../solution/ctrl'

export default class ServiceModalCtrl {
  constructor(close, $scope, id, services, $rootScope, ModalService, $sce) {
    this.close = close
    this.service = services.find((el) => { return el.id == id })
    this.ModalService = ModalService
    this.$rootScope = $rootScope

    this.carouselIndex = 0

    this.serviceSolutions = $rootScope.solutions.filter((el) => {
      return (this.service.solutions.includes(el.id))
    })

    $scope.trustSrc = function (src) {
      return $sce.trustAsResourceUrl(src);
    }

    $scope.trustHtml = function (html) {
      return $sce.trustAsHtml(html);
    }

  }

  close() {
    this.close()
  }

  openExternal(item) {
    if (item.blank) {
      window.open(item.url, '_blank')
    } else {
      this.ModalService.showModal({
        template: require('../external/view.html'),
        controller: ExternalModalCtrl,
        controllerAs: 'modal',
        inputs: {
          link: item.url
        },
        appendElement: angular.element(document.querySelector('#app-wrapper'))
      })
    }

  }

  openSolution(id) {
    this.$rootScope.$broadcast('close')
    this.close()

    for (let el of this.$rootScope.categories) {
      el.selected = false
    }

    this.$rootScope.$emit('categoryClear')

    this.ModalService.showModal({
      template: require('../solution/solution.html'),
      controller: SolutionModalCtrl,
      controllerAs: 'modal',
      inputs: {
        id: id,
        selected: false
      },
      appendElement: angular.element(document.querySelector('#app-wrapper'))
    })
  }

  next() {
    if (this.carouselIndex == (this.service.subpages.length - 1)) {
      this.carouselIndex = 0
      return
    }
    this.carouselIndex += 1
  }

  prev() {
    if (this.carouselIndex == 0) {
      this.carouselIndex = this.service.subpages.length
      return
    }
    this.carouselIndex -= 1
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/service/ctrl.js